import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { SelectedTargetItem } from "../../../Enrollment/types";
import { EditionEnrollmentTriggerPayload } from "../types";

export interface EditionEnrollmentSubmitArgs {
  trigger: EditionEnrollmentTriggerPayload;
  users: SelectedTargetItem[];
  groups: SelectedTargetItem[];
}

const buildUsersPayload = (
  trigger: EditionEnrollmentTriggerPayload,
  users: SelectedTargetItem[],
) => [
  {
    corporateId: Number(trigger.corporateId),
    editionId: trigger.editionId,
    objectId: trigger.objectId,
    isToj: false,
    userId: users.map((u) => Number(u.id)),
    mandatory: null,
    isAdmin: true,
  },
];

export const useEditionEnrollmentSubmit = () => {
  const { trigger: patchUsers, isMutating: isMutatingUsers } = useSWRMutation(
    ServicesURL.patchEnrollment,
    (url: string, { arg }: { arg: any[] }) =>
      fetcher<any>(url, MethodType.PATCH, arg),
    { onError: () => {} },
  );

  const { trigger: postGroup, isMutating: isMutatingGroups } = useSWRMutation(
    ServicesURL.postGroupEnrollmentUpload,
    (
      url: string,
      {
        arg,
      }: {
        arg: {
          objectId: number;
          editionId: number;
          corporateId: string | number;
          groupId: string | number;
        };
      },
    ) =>
      fetcher<any>(
        `${url}?objectId=${arg.objectId}&editionId=${arg.editionId}&corporateId=${arg.corporateId}&groupId=${arg.groupId}`,
        MethodType.POST,
      ),
    { onError: () => {} },
  );

  const submit = async ({
    trigger,
    users,
    groups,
  }: EditionEnrollmentSubmitArgs) => {
    if (users.length > 0) {
      await patchUsers(buildUsersPayload(trigger, users));
    }

    for (const g of groups) {
      await postGroup({
        objectId: trigger.objectId,
        editionId: trigger.editionId,
        corporateId: trigger.corporateId,
        groupId: g.id,
      });
    }
  };

  return {
    submit,
    isSubmitting: isMutatingUsers || isMutatingGroups,
  };
};
